import { CaseStatus } from '../../enums/case-status.enum';
import { UserStatus } from '../../enums/user-status.enum';

export class StatusUtils {
  // Case Status Details
  private static readonly CASE_STATUS_DETAILS: {
    [key in CaseStatus]: { class: string; text: string };
  } = {
    [CaseStatus.Open]: { class: 'badge-light-primary', text: 'Open' },
    [CaseStatus.AIAnalysing]: {
      class: 'badge-light-dark',
      text: 'AI Analysing',
    },
    [CaseStatus.AIAnalysingComplete]: {
      class: 'badge-light-success',
      text: 'AI AnalysingComplete',
    },
    [CaseStatus.WaitingConsultation]: {
      class: 'badge-light-warning',
      text: 'Waiting Consultation',
    },
    [CaseStatus.ReportSent]: { class: 'badge-light-info', text: 'Report Sent' },
    [CaseStatus.QuestionAsk]: {
      class: 'badge-light-body',
      text: 'Question Ask',
    },
    [CaseStatus.QuestionAnswer]: {
      class: 'badge-light-secondary',
      text: 'Question Answer',
    },
    [CaseStatus.Closed]: { class: 'badge-light-danger', text: 'Closed' },
  };

  // User Status Details
  private static readonly USER_STATUS_DETAILS: {
    [key in UserStatus]: { class: string; text: string };
  } = {
    [UserStatus.None]: { class: 'badge-light-default', text: 'None' },
    [UserStatus.NewAccount]: {
      class: 'badge-light-primary',
      text: 'New Account',
    },
    [UserStatus.Active]: { class: 'badge-light-success', text: 'Active' },
    [UserStatus.DeActive]: { class: 'badge-light-danger', text: 'DeActive' },
    [UserStatus.Blocked]: { class: 'badge-light-secondary', text: 'Blocked' },
    [UserStatus.Deleted]: { class: 'badge-light-default', text: 'Deleted' },
  };

  // Case Status Methods
  static getCaseStatusClass(status: CaseStatus): string {
    return this.CASE_STATUS_DETAILS[status]?.class;
  }

  static getCaseStatusText(status: CaseStatus): string {
    return this.CASE_STATUS_DETAILS[status]?.text;
  }

  // User Status Methods
  static getUserStatusClass(status: UserStatus): string {
    return this.USER_STATUS_DETAILS[status]?.class;
  }

  static getUserStatusText(status: UserStatus): string {
    return this.USER_STATUS_DETAILS[status]?.text;
  }

  // Filter Case Statuses
  private static readonly FILTER_CASE_STATUSES: {
    [key in CaseStatus]?: { id: string; title: string };
  } = {
    [CaseStatus.Open]: { id: '1', title: 'Open' },
    [CaseStatus.WaitingConsultation]: {
      id: '2',
      title: 'Waiting Consultation',
    },
    [CaseStatus.ReportSent]: { id: '3', title: 'Report Sent' },
    [CaseStatus.QuestionAsk]: { id: '4', title: 'Question Ask' },
    [CaseStatus.QuestionAnswer]: { id: '5', title: 'Question Answer' },
    [CaseStatus.Closed]: { id: '6', title: 'Closed' },
  };

  static getFilterCaseStatuses(): Array<{ id: string; title: string }> {
    return Object.values(this.FILTER_CASE_STATUSES);
  }
}
